import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
// import App from './App';
import AppFC from "./AppFC";
import { BrowserRouter } from "react-router-dom";
import reportWebVitals from "./reportWebVitals";
import Auth0ProviderWithHistory from "./auth/Auth0ProviderWithHistory";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Auth0ProviderWithHistory>
        <AppFC />
      </Auth0ProviderWithHistory>
    </BrowserRouter>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
